import React from 'react';

const Notifications = React.createContext();

export default Notifications;
